import React from "react";
import { useToggleModal } from "../../../../lib/hooks/useToggleModal";
import { ContactSalesModal } from "../../../ContactSales/ContactSalesModal";
import { Button } from "../../../shared/Button/Button";
import { Icon } from "../../../shared/Icon/Icon";

import "./BillingHelp.scss";

export const BILLING_HELP_KNOWLEDGE_BASE_URL = "https://support.gogetcorp.com/";

interface BillingHelpItemProps {
  icon: React.ReactNode;
  tone: "teal" | "blue";
  title: string;
  text: string;
  children: React.ReactNode;
}

const BillingHelpItem = ({
  icon,
  tone,
  title,
  text,
  children,
}: BillingHelpItemProps) => (
  <div className="BillingHelp__item Subscriptions__panel">
    <span
      className={`BillingHelp__icon BillingHelp__icon--${tone} flex-center`}
      aria-hidden="true"
    >
      {icon}
    </span>
    <div className="BillingHelp__body">
      <h3>{title}</h3>
      <p>{text}</p>
      {children}
    </div>
  </div>
);

export const BillingHelp = () => {
  const { isOpen, toggleModal } = useToggleModal();

  return (
    <section
      className="BillingHelp Subscriptions__card default-box"
      aria-labelledby="billing-help-title"
    >
      <h2 id="billing-help-title" className="Subscriptions__cardTitle">
        Need help?
      </h2>

      <BillingHelpItem
        icon="?"
        tone="teal"
        title="Billing questions"
        text="Visit our knowledge base for billing, payments and pricing information."
      >
        <a
          href={BILLING_HELP_KNOWLEDGE_BASE_URL}
          className="BillingHelp__link"
          target="_blank"
          rel="noopener noreferrer"
        >
          Open knowledge base <span aria-hidden="true">→</span>
        </a>
      </BillingHelpItem>

      <BillingHelpItem
        icon={<Icon icon="headset-icon" />}
        tone="blue"
        title="Contact sales support"
        text="Our team can help with your plan, hardware and deployment needs."
      >
        <Button
          title="Contact sales"
          className="BillingHelp__button Subscriptions__button"
          onClick={toggleModal}
        />
      </BillingHelpItem>

      {isOpen && <ContactSalesModal isOpen={isOpen} toggle={toggleModal} />}
    </section>
  );
};
